<template>
  <div class="app hcps-styling">
    <router-view :key="$route.name" />
  </div>
</template>
<script>

export default {
  name: 'App'
}
</script>
<style lang="scss">
body, .app {
  background-color: #fff;
  height: 100%;
}

.app {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
